
import React, { useState, useEffect, useContext } from "react";
import AdminContext from "../../../StateContext/Application";
import { apiurl } from "../../../../../path";
import {
  PDF32,
  Time32,
  UpdateWhite32,
  Excel32,
  JPG32,
  PNG32,
  AddFile32,
  VendorName32,
  Bank32,
  barely_black_bg_img,
  Cancel32,
  Email32,
  Location32,
  PhoneNumber32,
  submit,
  Edit32WHITE,
  Approved32
} from "../../../../../public/LoginImages/importimages";
// 18-09
import CreateProject from "../../ProjectManagement/CreateProject/CreateProject";

// 08-10 status color
const STATUS_STYLES = {
  pending: {
    label: "Pending",
    color: "#F59E0B",
    textColor: "#E8890C",
    bg: "#FFFFFF",
    img: "/Pending icon 32 Size.png",
  },
  sendback: {
    label: "Send Back",
    color: "#0D6EFD",
    textColor: "#0D6EFD",
    bg: "#FFFFFF",
    img: "/send back 32 size.png",
  },
  approved: {
    label: "Approved",
    color: "#39B54A",
    textColor: "#39B54A",
    bg: "#FFFFFF",
    img: "/Approved  32 Size.png",
  },
  rejected: {
    label: "Rejected",
    color: "#FF5C6C",
    textColor: "#FF5C6C",
    bg: "#FFFFFF",
    img: "/Reject 32 size.png",
  },
};
 
const StatusBadge = ({ status }) => {
  const key = (status || "").replace(/\s+/g, "").toLowerCase();
 
  const s = STATUS_STYLES[key] || STATUS_STYLES.pending;
 
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "6px",
        minWidth: "95px",
        padding: "5px 12px",
        border: `1px solid ${s.color}`,
        borderRadius: "20px",
        color: s.textColor,
        backgroundColor: s.bg,
        fontSize: "12px",
        fontWeight: "600",
        whiteSpace: "nowrap",
      }}
    >
      <img
        src={s.img}
        alt={s.label}
        style={{ width: "18px", height: "18px", objectFit: "contain" }}
      />
      {s.label}
    </span>
  );
};
 
const ProjectList = () => {
  const context = useContext(AdminContext);
  const { GetAllProjectList,GetProjectList, ProjectApproval, Usermenu, GetProjectInfo } = context;
  const [project, setProjectList] = useState([]);
  const [filteredBills, setFilteredBills] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const billsPerPage = 10;
  const [searchTerm, setSearchTerm] = useState("");
 const [statusFilter, setStatusFilter] = useState("All");
//  18-09
 const [menuData, setMenuData] = useState({});
 const [showEditForm, setShowEditForm] = useState(false);
 const [editProjectData, setEditProjectData] = useState(null);
  const totalPages = Math.ceil((filteredBills?.length || 0) / billsPerPage);
  const indexOfLastBill = currentPage * billsPerPage;
  const indexOfFirstBill = indexOfLastBill - billsPerPage;
  const currentBills = Array.isArray(filteredBills)
    ? filteredBills.slice(indexOfFirstBill, indexOfLastBill)
    : [];

  //  comment on 04/09/ for soting sequence

  const getProjectList = async () => {
    let data = await GetAllProjectList();
    console.log("data", data);
    const projectData = data?.result || [];
    const sortedData = [...projectData].sort(
      (a, b) => new Date(b.Date) - new Date(a.Date),
    );
    setProjectList(sortedData);
    setFilteredBills(sortedData);
  };

  useEffect(() => {
    getProjectList();
  }, []);

  let projectList = [];
  if (project.length > 0) {
    projectList = project;
  }


// above usefect comment for sattus filter 16-09
 useEffect(() => {
    const lowerSearchTerm = searchTerm.toLowerCase();
 
    const filtered = project.filter((bill) => {
        const matchesSearch = Object.values(bill).some((val) =>
            (val || "").toString().toLowerCase().includes(lowerSearchTerm)
        );
 
        const matchesStatus =
            statusFilter === "All" ||
            (bill.Status || "").toLowerCase() === statusFilter.toLowerCase();
 
        return matchesSearch && matchesStatus;
    });
 
    setFilteredBills(filtered);
    setCurrentPage(1);
}, [searchTerm, statusFilter, project]);
  const getPageNumbers = (currentPage, totalPages) => {
    const maxVisiblePages = 5;

    // Total pages 5 ya usse kam hain
    if (totalPages <= maxVisiblePages) {
      return Array.from({ length: totalPages }, (_, index) => index + 1);
    }

    // Starting pages
    // 1 2 3 4 5 ... Last
    if (currentPage <= 3) {
      return [1, 2, 3, 4, 5, "...", totalPages];
    }

    // Last pages
    // ... 16 17 18 19 20
    if (currentPage >= totalPages - 2) {
      return [
        "...",
        totalPages - 4,
        totalPages - 3,
        totalPages - 2,
        totalPages - 1,
        totalPages,
      ];
    }

    // Middle pages
    // ... 4 5 6 7 8 ... 20
    return [
      "...",
      currentPage - 2,
      currentPage - 1,
      currentPage,
      currentPage + 1,
      currentPage + 2,
      "...",
      totalPages,
    ];
  };

// 18-09
  useEffect(() => {
    const getMenu = async () => {
      const res = await Usermenu();
      setMenuData(res?.Data || {});
    };
    getMenu();
  }, []);
  
  const isMaker =
    menuData?.Department_Name === "State Maker" &&
    menuData?.Role === "State Maker";
    const handleEditProject = async (project) => {
    try {
      const res = await GetProjectInfo(project.ProjectId, "id");
      setEditProjectData(res[0]);
      setShowEditForm(true);
    } catch (err) {
      console.log(err);
    }
  };
  
  const handleApproveProject = async (project) => {
    const shouldProceed = window.confirm("Are you sure you want to approve this Project?");
    if (!shouldProceed) return;
  
    try {
      const response = await ProjectApproval([project.ProjectId], "Approved");
      if (response?.message) alert(response.message);
      else if (response?.error) alert(response.error);
      getProjectList(); // refresh list
    } catch (err) {
      console.error("Error approving Project:", err);
      alert("An error occurred while approving.");
    }
  };

  const thStyle = {
  padding: 10,
  position: "sticky",
  top: 0,
  zIndex: 2,
  // background: "#E5EBFA",
};
   return (
     <>
   
     {!showEditForm ? (
     <div
       style={{
         width: "100%",
 height: "auto",              // new
     display: "flex",             // new
     flexDirection: "column",
         backgroundColor: "white",
 
         //29/10
         padding: "20px 15px 15px 15px",
         boxSizing: "border-box",
         overflow: "hidden",
         fontFamily: "Inter, sans-serif",
       }}
     >
       {/* //29/10 */}
        <div
       style={{
         width: "100%",
         background: "#EEF1F6",
         borderRadius: "12px",
         padding: "18px 15px",
         boxSizing: "border-box",
         boxShadow: "0 3px 10px rgba(0, 0, 0, 0.10)",
         border: "1px solid #E1E6EF",
       }}
     >
       <div
         style={{
           width: "100%",
           height: "42px",
           marginBottom: "10px",
           display: "flex",
           alignItems: "center",
           justifyContent: "space-between",
           boxSizing: "border-box",
           flexShrink: 0,
           gap: "20px",
         }}
       >
         <h5
           style={{
             margin: 0,
             fontWeight: "700",
             fontSize: "18px",
             color: "#111",
             display: "flex",
             alignItems: "center",
             whiteSpace: "nowrap",
           }}
         >
           <img
     src="/Project-Inward-List-32.png"
     alt="img"
    
   />{" "}
           Project Outward List
         </h5>
          <div style={{display:"flex",justifyContent:"center",gap:"10px"}}>
         <div
           style={{
             position: "relative",
             width: "250px",
             minWidth: "250px",
             height: "36px",
             display: "flex",
             alignItems: "center",
             border: "1px solid #cfd8e3",
             borderRadius: "7px",
             padding: "5px 10px",
             boxSizing: "border-box",
              backgroundColor:"white",
             marginLeft: "auto",
           }}
         >
           <img
             src={"/Search-32.png"}
             alt="search"
             style={{
               width: "17px",
               height: "17px",
               marginRight: "7px",
               flexShrink: 0,
             }}
           />
           <input
             value={searchTerm}
             onChange={(e) => setSearchTerm(e.target.value)}
             placeholder="Search Project..."
             style={{
               border: "none",
               outline: "none",
               background: "transparent",
               width: "100%",
               fontSize: "13px",
               color: "#333",
             }}
           />
         </div>
         <select
     value={statusFilter}
     onChange={(e) => setStatusFilter(e.target.value)}
     style={{
         width: "140px",
         height: "36px",
         marginLeft: "10px",
         border: "1px solid #d5dce5",
         borderRadius: "8px",
         padding: "0 10px",
         fontSize: "12px",
         outline: "none",
         background: "#fff",
         cursor: "pointer"
     }}
 >
     <option value="All">All Status</option>
     <option value="Pending">Pending</option>
     <option value="SendBack">SendBack</option>
     <option value="Approved">Approved</option>
     <option value="Rejected">Rejected</option>
 </select>
       </div></div>
 
       <div
         style={{
           width: "100%",
           maxWidth: "100%",
 
           // height: "calc(100% - 52px)",
 
           margin: "10px auto 0 auto",
 
           backgroundColor: "#ffffff",
 
           borderRadius: "14px",
 
           boxShadow: "0 3px 12px rgba(0, 0, 0, 0.15)",
 
           padding: "0 18px 18px 18px",
           paddingTop: "18px",
           boxSizing: "border-box",
 
           display: "flex",
           flexDirection: "column",
           overflow: "hidden",
           //28/10
            flex: "0 1 auto",
           minWidth: 0,
           minHeight: 0,
           // height: "auto",
 
           // flexShrink: 0,
         }}
       >
         <div
           style={{
             width: "100%",
             // height: "100%",
             minWidth: 0,
             minHeight: 0,
             overflowX: "auto",
             overflowY: "auto",
             border: "1px solid #d9e1f2",
             borderRadius: "10px",
 
             backgroundColor: "#ffffff",
 
             boxShadow: "0 2px 8px rgba(0, 0, 0, 0.10)",
 
             boxSizing: "border-box",
 
             flex: "1 1 auto",
 
             WebkitOverflowScrolling: "touch",
 
             scrollbarWidth: "thin",
           }}
         >
           {/* //28/10 */}
           <table
   style={{
     backgroundColor: "#ffffff",
     width: "max-content",
     minWidth: "1700px",
     borderCollapse: "separate",
     borderSpacing: 0,
     fontSize: "11px",
   }}
 >
             <thead>
               {/* //28/10 */}
               <tr
                 style={{
                   backgroundColor: "#2D79D9",
                   color: "white",
                   border: "none",
                   height: "34px",
                   fontSize: "14px",
                   fontWeight: "500",
                   textAlign: "center",
                   // whiteSpace: "normal",
                 }}
               >
                 <th style={thStyle}>Sr.No</th>
                 <th style={thStyle}>Scheme Type</th>
                 <th style={thStyle}>Financial Year</th>
                 <th style={thStyle}>Project ID</th>
                 <th style={thStyle}>Project Name</th>
                 <th style={thStyle}>Project Details</th>
                 {/* <th style={thStyle}>Object Code</th>
                                 <th style={thStyle}>CRC</th> */}
                 <th style={thStyle}>Implementing Agency</th>
                 <th style={thStyle}>Project Cost</th>
                 <th style={thStyle}>Project Completion Date</th>
                 <th style={thStyle}>GRNumber</th>
                 <th style={thStyle}>GRDate</th>
                 <th style={thStyle}>GRCopy</th>
                 <th style={thStyle}>Creation Date</th>
                 <th style={thStyle}>Remark</th>
                 <th style={thStyle}>Status</th>
                  {/* 18-09 */}
                 {isMaker && <th style={thStyle}>Action</th>}
 {isMaker && <th style={thStyle}>Approve</th>}
               </tr>
             </thead>
            <tbody>
             {/* //3/11 */}
   {currentBills?.map((project, index) => (
     <tr
       key={project.ProjectId || index}
       style={{
         backgroundColor: index % 2 === 0 ? "#E5F4FB" : "#CEE4F1",
         fontSize: "13px",
         fontWeight: 500,
         textAlign: "center",
       }}
     >                 
     {/* //3/11 */}
                     <td style={{border:"1px solid white"}}>{(currentPage - 1) * billsPerPage + index + 1}</td>
                       {/* //3/11 */}
                     <td style={{ padding: 10, border:"1px solid white" }}>{project.Scheme}</td>
                       {/* //3/11 */}
                     <td style={{ padding: 10, border:"1px solid white" }}>{project.FinancialYear}</td>
                     {/* //3/11 */}
                     <td style={{ padding: 10 ,color:"blue",border:"1px solid white"}}>{project.ProjectId}</td>
                       {/* //3/11 */}
                     <td style={{ padding: 10 ,whiteSpace: "normal", wordBreak: "break-word",overflowWrap: "break-word", maxWidth: "200px",  lineHeight: "1.4", border:"1px solid white"}}>{project.ProjectName}</td>
                      {/* //3/11 */}
                     <td style={{ padding: 10 ,whiteSpace: "normal", wordBreak: "break-word",overflowWrap: "break-word", maxWidth: "200px",  lineHeight: "1.4", border:"1px solid white"}}>{project.ProjectDetails}</td>
                     {/* <td style={{ padding: 10 }}>{project.ObjectCode}</td>
                                             <td style={{ padding: 10 }}>{project.CRC}</td> */}
                     <td style={{ padding: 10 ,whiteSpace: "normal", wordBreak: "break-word",overflowWrap: "break-word", maxWidth: "200px",  lineHeight: "1.4", border:"1px solid white"}}>{project.Agency_Name}</td>
                     {/* <td style={{ padding: 10 }}>
                       {" "}
                       {Number(project.ProjectCost || 0).toLocaleString("en-US")}
                     </td> */}
                     <td style={{ padding: 10, border:"1px solid white" }}>
                       {Number(project.ProjectCost || 0).toLocaleString("en-IN")}
                     </td>
                     <td style={{ padding: 10, whiteSpace: "nowrap", border:"1px solid white" }}>
                       <img
                         src={"/Time-32.png"}
                         style={{
                           marginRight: "5px",
                           width: "15px",
                           height: "15px",
                         }}
                       />
                       {project.ProjectEstCompletionDate?.split("T")[0].replace(
                         " ",
                       )}
                     </td>
                     <td style={{ padding: 10, border:"1px solid white" }}>{project.GRNumber}</td>
                     <td style={{ padding: 10, whiteSpace: "nowrap",border:"1px solid white" }}>
                       <img
                         src={"/Time-32.png"}
                         style={{
                           marginRight: "5px",
                           width: "15px",
                           height: "15px",
                         }}
                       />
                       {project.GRDate?.split("T")[0].replace(" ")}
                     </td>
                     <td  style={{
                                     padding: "8px",
                                     minWidth: "160px",
                                     width: "160px",
                                     maxWidth: "160px",
                                     whiteSpace: "nowrap",
                                     textAlign: "center",
                                     border:"1px solid white"
                                   }}>
                       {project.GRCopy ? (
                         (() => {
                           const ext = project.GRCopy.split(".")
                             .pop()
                             .toLowerCase();
                           let icon;
                           if (ext === "xls" || ext === "xlsx") {
                             icon = Excel32; // 🟢 Replace with your actual XLS icon import
                           } else if (ext === "jpg" || ext === "jpeg") {
                             icon = JPG32; // 🟢 Replace with your actual JPG icon import
                           } else if (ext === "png") {
                             icon = PNG32; // 🟢 Replace with your actual PNG icon import
                           } else if (ext === "pdf") {
                             icon = PDF32; // 🟢 Replace with your actual PNG icon import
                           } else {
                             icon = UpdateWhite32; // default icon (optional)
                           }
                       //     return (
                       //       <a
                       //         href={`${apiurl}/ProjectDocsImages/${project.GRCopy}`}
                       //         target="_blank"
                       //          style={{
                       //                       display: "flex",
                       //                       alignItems: "center",
                       //                       justifyContent: "center",
                       //                       gap: "5px",
                       //                       width: "100%",
                       //                       overflow: "hidden",
                       //                       textDecoration: "none",
                       //                       color: "#0d6efd",
                       //                     }}
                       //       >
                       //         <img
                       //           src={icon}
                       //           alt={ext + " icon"}
                       //           style={{
                       //                         width: "20px",
                       //                         height: "20px",
                       //                         flexShrink: 0,
                       //                       }}
                       //         />
                       //         {project.GRCopy}
                       //       </a>
                       //     );
                       //   })()
                       // ) : (
                       //   <span style={{ color: "#d9534f", fontWeight: 700 }}>
                       //     No File
                       //   </span>
                       // )}
                       return (
         <a
           href={`${apiurl}/ProjectDocsImages/${project.GRCopy}`}
           target="_blank"
           rel="noreferrer"
           title={project.GRCopy}   // 🔵 full filename shown on hover
           style={{
             display: "flex",
             alignItems: "center",
             justifyContent: "center",
             gap: "5px",
             width: "100%",
             overflow: "hidden",
             textDecoration: "none",
             color: "#0d6efd",
           }}
         >
           <img
             src={icon}
             alt={ext + " icon"}
             style={{
               width: "20px",
               height: "20px",
               flexShrink: 0,
             }}
           />
           {project.ProjectId} GR Copy  {/* 🔵 CHANGED — fixed short label instead of project.GRCopy */}
         </a>
       );
     })()
   ) : (
     <span style={{ color: "#d9534f", fontWeight: 700 }}>No File</span>
   )}
                     </td>
                     <td style={{ padding: 10, border:"1px solid white" }}>
                       {project.Date?.split("T")[0].replace(" ")}
                     </td>
                     <td style={{ padding: 10, border:"1px solid white" }}>
                       {project.CheckerRemark || "-"}
                     </td>
                     {/* <td style={{padding:10}}>{project.Status || "-"}</td> */}
                       <td style={{ padding: "10px", textAlign: "center", border:"1px solid white" }}>
   <StatusBadge status={project. Status} />
 </td>
  
                       {/* 18-09 */}
                                         {isMaker && (
                       <td style={{ padding: 10, textAlign: "center", border:"1px solid white" }}>
                         <button
                           onClick={() => handleEditProject(project)}
                           disabled={project.Status !== "SendBack"}
                           style={{
                             display: "flex",
                             alignItems: "center",
                             justifyContent: "center",
                             gap: "5px",
                             margin: "auto",
                             padding: "6px 12px",
                             background:
                               project.Status === "SendBack" ? "#0D6EFD" : "rgba(141,141,141,0.97)",
                             color: "#fff",
                             border: "none",
                             borderRadius: "6px",
                             fontSize: "13px",
                             fontWeight: "600",
                             cursor: project.Status === "SendBack" ? "pointer" : "not-allowed",
                           }}
                         >
                           <img src={Edit32WHITE} alt="Edit" style={{ width: "14px", height: "14px" }} />
                           Edit
                         </button>
                       </td>
                     )}
                     
                     {isMaker && (
                       <td style={{ padding: 10, textAlign: "center",border:"1px solid white" }}>
                         <button
                           onClick={() => handleApproveProject(project)}
                           disabled={project.Status !== "SendBack"}
                           style={{
                             display: "flex",
                             alignItems: "center",
                             justifyContent: "center",
                             gap: "5px",
                             margin: "auto",
                             padding: "6px 12px",
                             background:
                               project.Status === "SendBack" ? "#39B54A" : "rgba(141,141,141,0.97)",
                             color: "#fff",
                             border: "none",
                             borderRadius: "6px",
                             fontSize: "13px",
                             fontWeight: "600",
                             cursor: project.Status === "SendBack" ? "pointer" : "not-allowed",
                           }}
                         >
                           <img src={Approved32} alt="Approve" style={{ width: "14px", height: "14px" }} />
                           Approve
                         </button>
                       </td>
                     )}
                      </tr>
   ))}
 </tbody>
           </table>
 
           {/* 29-09 add msg no data */}
             {(!Array.isArray(currentBills) || currentBills.length === 0) && (
             <div
               style={{
                 position: "sticky",
                 left: 0,
                 width: "100%",
                 display: "flex",
                 justifyContent: "center",
                 alignItems: "center",
                 height: "150px",
                 boxSizing: "border-box",
                 backgroundColor: "#f9f9f9",
                 color: "black",
                 fontSize: "15px",
                 fontWeight: 500,
               }}
             >
               No Project Available
             </div>
           )}
           
         </div>
 
         <div
           style={{
             width: "100%",
             flexShrink: 0,
             display: "flex",
             alignItems: "center",
             justifyContent: "space-between",
             marginTop: "15px",
             padding: "10px 5px",
             boxSizing: "border-box",
             overflow: "hidden",
           }}
         >
           {/* Showing */}
           <div
             style={{
               fontSize: "13px",
               color: "#333",
               whiteSpace: "nowrap",
             }}
           >
             Showing {filteredBills?.length === 0 ? 0 : indexOfFirstBill + 1} to{" "}
             {Math.min(indexOfLastBill, filteredBills?.length || 0)} of{" "}
             {filteredBills?.length || 0} entries
           </div>
 
           {/* Pagination */}
           <div
             style={{
               display: "flex",
               alignItems: "center",
               gap: "18px",
             }}
           >
             {/* Previous */}
             <button
               onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
               disabled={currentPage === 1}
               style={{
                 border: "none",
                 background: "transparent",
                 color: currentPage === 1 ? "#999" : "#2ea4e7",
                 cursor: currentPage === 1 ? "not-allowed" : "pointer",
                 fontSize: "13px",
                 padding: 0,
                 display: "flex",
                 alignItems: "center",
                 gap: "4px",
                 opacity: currentPage === 1 ? 0.5 : 1,
               }}
             >
               <span style={{ fontSize: "20px" }}>‹</span>
               Previous
             </button>
 
             {/* Page Numbers */}
             {getPageNumbers(currentPage, totalPages).map(
               (pageNumber, index) => {
                 // Dots ko button mat banana
                 if (pageNumber === "...") {
                   return (
                     <span
                       key={`ellipsis-${index}`}
                       style={{
                         fontSize: "13px",
                         color: "#444",
                       }}
                     >
                       ...
                     </span>
                   );
                 }
 
                 return (
                   <button
                     key={pageNumber}
                     onClick={() => setCurrentPage(pageNumber)}
                     style={{
                       border: "none",
                       background: "transparent",
                       padding: 0,
                       color: currentPage === pageNumber ? "#2ea4e7" : "#444",
                       cursor: "pointer",
                       fontSize: "13px",
                       fontWeight: currentPage === pageNumber ? "600" : "400",
                       textDecoration:
                         currentPage === pageNumber ? "underline" : "none",
                     }}
                   >
                     {pageNumber}
                   </button>
                 );
               },
             )}
             {/* Next */}
             <button
               onClick={() =>
                 setCurrentPage((prev) => Math.min(prev + 1, totalPages))
               }
               disabled={currentPage === totalPages || totalPages === 0}
               style={{
                 border: "none",
                 background: "transparent",
                 color:
                   currentPage === totalPages || totalPages === 0
                     ? "#999"
                     : "#2ea4e7",
                 cursor:
                   currentPage === totalPages || totalPages === 0
                     ? "not-allowed"
                     : "pointer",
                 fontSize: "13px",
                 padding: 0,
                 display: "flex",
                 alignItems: "center",
                 gap: "4px",
                 opacity:
                   currentPage === totalPages || totalPages === 0 ? 0.5 : 1,
               }}
             >
               Next
               <span style={{ fontSize: "20px" }}>›</span>
             </button>
           </div>
         </div>
       </div>
    
    </div> </div>
      ): (
       <CreateProject
         isEdit={true}
         projectData={editProjectData}
         onSuccess={() => {
           setShowEditForm(false);
           getProjectList(); // refresh table
         }}
         onCancel={() => {
           setShowEditForm(false);
         }}
       />
     )}
        
     </>
 
   );
};

export default ProjectList;
